module.exports = __webpack_public_path__ + "img/ver2.a5882963.jpg";